module.exports = __webpack_public_path__ + "static/img/asa.76618c3d.svg";